import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { Quote } from '../../model/quote/quote.model';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AlCalculationsDetails } from '../al-calculations/al-calculations.model';
import { AlQuoteService } from '../al-quote.service';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-admin-al-quotation',
  templateUrl: './al-quotation.component.html',
  styleUrls: ['../../../quote.component.css']
})
export class AdminAlQuotationComponent implements OnInit {
  @Output() BackToSOFDetails = new EventEmitter();
  @Output() proceedToPayment = new EventEmitter();
  @Output() quoteDetailsUpdated = new EventEmitter<Quote>();
  @Input() quoteDetails: Quote;
  Calculations = new AlCalculationsDetails();
  client_website_link: string = '';

  constructor(private quoteService: AlQuoteService, private _snackBar: MatSnackBar) { }

  quote;
  ngOnInit(): void {
    this.quote = this.quoteDetails;
    this.client_website_link = environment.CLIENT_WEBSITE_LINK;
  }

  ngOnChanges(changes: SimpleChanges) {
    this.quote = this.quoteDetails;
  }

  /*
  * BACK TO SOF
  */
  backToSOFTab() {
    this.BackToSOFDetails.emit();
  }

  /*
  * Save Quote
  */
  saveQuote() {

  }

  /*
  * Convert to Policy
  */
  convertToPolicy() {
    let data: any = '';
    data = {
      quote_id: this.quote.quote_versions[0].id,
      policy_ref_number: this.quote.quote_versions[0].policy_ref_number
    };
    this.quoteService.convertToPolicy(data)
      .subscribe(
        (response: any) => {
          if (response.success) {
            this.quote = response.result;
            this.quoteDetailsUpdated.emit(this.quote);
            this.proceedToPayment.emit();
          } else {
            this._snackBar.open(response.message, '', {
              duration: 5000,
              panelClass: 'text-danger'
            });
          }

        });

  }
}
